import { css } from '@emotion/core';
import { IToken } from '../../shared/contexts/styleContext';

export const frameVariableListStyle = (Token: IToken) => css`
    padding: ${Token.spacings.smaller};
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;
